"use strict";
exports.__esModule = true;
var common_1 = require("../models/common");
var validateExample = function (value, activationPhrases) {
    if (value === '') {
        return '';
    }
    if (!common_1.containsOneOf(value, common_1.triggers)) {
        return "\u041F\u0440\u0438\u043C\u0435\u0440 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u043E\u0434\u043D\u043E \u0438\u0437 \u0441\u043B\u043E\u0432 " + common_1.quotedTriggers;
    }
    if (!common_1.containsOneOf(value, activationPhrases)) {
        return "\u041F\u0440\u0438\u043C\u0435\u0440 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u043E\u0434\u043D\u043E \u0438\u0437 \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0438\u043C\u0451\u043D";
    }
    return '';
};
exports["default"] = validateExample;
